import type { CSSProperties } from 'react';

import { StyledCircle, StyledSvg } from './styles';

const defaultOptions = {
  svg: {
    stroke: '#dedede',
    strokeWidth: '4',
    r: 21,
    cx: '50%',
    cy: '50%',
    fill: 'none',
  },
  style: {
    width: '46px',
    height: '46px',
  },
  className: '',
};

type CircularLoaderProps = {
  options?: {
    svg?: {
      cx?: string | number;
      cy?: string | number;
      r?: string | number;
      stroke?: string;
      strokeWidth?: string | number;
      fill?: string;
    };
    style?: CSSProperties;
    className?: string;
  };
};
export const CircularLoader = ({ options }: CircularLoaderProps) => {
  const finalOptions = {
    ...defaultOptions,
    ...options,
  };
  return (
    <StyledSvg className={finalOptions.className} style={finalOptions.style}>
      <StyledCircle
        cx={finalOptions.svg.cx}
        cy={finalOptions.svg.cy}
        r={finalOptions.svg.r}
        stroke={finalOptions.svg.stroke}
        strokeWidth={finalOptions.svg.strokeWidth}
        fill={finalOptions.svg.fill}
      />
    </StyledSvg>
  );
};
